import { useState, useEffect } from "react";
import moment from "moment";

export const useMonthFilter = () => {
  const [selectedMonth, setSelectedMonth] = useState(() => {
    try {
      const stored = localStorage.getItem("selectedMonth");

      if (stored) {
        const { month, year } = JSON.parse(stored);

        // validate month-year strictly
        const parsed = moment(`${year}-${month}`, "YYYY-MM", true);

        if (parsed.isValid()) {
          return parsed;
        }
      }
    } catch (error) {
      console.error("Error parsing selectedMonth from localStorage:", error);
    }

    // fallback → current month
    return moment();
  });

  useEffect(() => {
    try {
      const month = selectedMonth.format("MM");
      const year = selectedMonth.format("YYYY");

      localStorage.setItem(
        "selectedMonth",
        JSON.stringify({ month, year })
      );
    } catch (error) {
      console.error("Error saving selectedMonth to localStorage:", error);
    }
  }, [selectedMonth]);

  return {
    selectedMonth,
    setSelectedMonth,
  };
};